<ion-grid fixed class="ion-no-padding">
  <ion-row>
    <ion-col size="12">
      <ion-card color="secondary" (click)="add(2)">
        <ion-item color="tertiary" lines="none" detail="true">
          <ion-icon slot="start" name="videocam"></ion-icon>
          <ion-label>
            <h2>
              Videollamada
            </h2>
          </ion-label>
        </ion-item>
      </ion-card>
      <ion-card color="secondary" (click)="add(1)">
        <ion-item color="tertiary" lines="none" detail="true">
          <ion-icon slot="start" name="compass"></ion-icon>
          <ion-label>
            <h2>
              Presencial
            </h2>
          </ion-label>
        </ion-item>
      </ion-card>
      <ion-card color="secondary" (click)="add(3)">
        <ion-item color="tertiary" lines="none" detail="true">
          <ion-icon slot="start" name="call"></ion-icon>
          <ion-label>
            <h2>
              Llamada
            </h2>
          </ion-label>
        </ion-item>
      </ion-card>
      <ion-card color="danger" (click)="close()">
        <ion-item color="danger" lines="none">
          <ion-icon slot="start" name="close"></ion-icon>
          <ion-label>
            <h2>
              Cancelar
            </h2>
          </ion-label>
        </ion-item>
      </ion-card>
    </ion-col>
  </ion-row>
</ion-grid>
